import React, { useState, useEffect } from 'react';
import ValidateFields from '../../modules/tools/ValidateFields';
import { FieldsMapToState, FieldsMap } from '../../handlers/MUIGenerateFields';
import Auth from '../../modules/auth/Auth';
import GenericTools from '../../modules/tools/GenericTools';
import FieldsErrorPopup from './../../components/popups/FieldErrorPopup';
//css
import { makeStyles } from '@material-ui/core/styles';
import './LoginWithPhone.scss';
import FirstScreen from './FirstScreen';
import '../register/rSteps/RStep.scss'


const fields = {
    phone: {
        name: "טלפון",
        label: "",
        type: "TextField",
        // required: true,
        validateInput: ValidateFields.validatePhoneInput,
        inputType: "string",
        id: "outlined-helperText",
        variant: "outlined",
        // defaultValue: ''
    },
    pincode: {
        name: "קוד אימות",
        label: "",
        type: "TextField",
        // required: true,
        validateInput: ValidateFields.validateNumberInput,
        inputType: "number",
        id: "outlined-helperText",
        variant: "outlined",
        // defaultValue: ''
    }
}

const useStyles = makeStyles({
    root: {
        marginBottom: "6vw",
        width: "calc(100vw-3rem)",
    },
});

const LoginWithPhone = (props) => {
    const [fieldsState, setFieldsState] = useState(FieldsMapToState(fields));
    const [isPinSent, setIsPinSent] = useState(false);
    const [isFirstScreen, setIsFirstScreen] = useState(true);
    const [isErrorPopup, setIsErrorPopup] = useState(false);


    const classes = useStyles();

    const pinSent = () => setIsPinSent(isPinSent => !isPinSent);

    const handleValidation = async (e, fieldName, field) => {
        let value = e.target && e.target.value;
        let required = field.required;
        let error = await field.validateInput(value, required, field.name, field.inputLength);
        let isValid = false;
        if (!error) isValid = true;
        setFieldsState({ ...fieldsState, [fieldName]: { value, error, isValid } })
    }

    const validateForm = (fieldsToValidate = fieldsState) => {
        for (let field in fieldsToValidate) {
            if (!fieldsToValidate[field].isValid) return false;
        }
        return true;
    }

    const sendPin = async () => {
        if (!validateForm({ phone: fieldsState.phone }) || !fieldsState.phone.value) {
            setIsErrorPopup(true);
            return;
        }
        const search = (props.history && props.history.location.search) || "";
        // if (!search) { setIsLinkValid(false); return; }

        let [sendPinRes, sendPinErr] = await Auth.superAuthFetch(`/api/CustomUsers/sendLoginRegisterPincodeSMS${search}`, {
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            method: "POST",
            body: JSON.stringify({ phone: fieldsState.phone.value })
        }, true);
        if (sendPinErr) {
            console.log("Error sending pin to phone", sendPinErr);
            setIsErrorPopup(true);
            return;
        }
        setIsErrorPopup(false);
        pinSent();
    }

    const login = async () => {
        if (!validateForm({ pincode: fieldsState.pincode }) || !fieldsState.pincode.value) {
            setIsErrorPopup(true);
            return;
        }

        let [validatePinRes, validatePinErr] = await Auth.superAuthFetch(`/api/CustomUsers/validateLoginPincode`, {
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            method: "POST",
            body: JSON.stringify({ pincode: fieldsState.pincode.value, phone: fieldsState.phone.value })
        }, true);
        if (validatePinErr) {
            console.log("Error logging-in with pincode", validatePinErr);
            setIsErrorPopup(true);
            return;
        }

        GenericTools.safe_redirect("/");
        window.location.reload();
    }

    const fieldsToShow = FieldsMap(fields, handleValidation, fieldsState, classes.root);

    if (isFirstScreen) return (
        <div className="login-with-phone-container r-step-container">
            <FirstScreen onClick={() => setIsFirstScreen(false)} />
        </div>
    );
    return (
        <div className="login-with-phone-container  r-step-container" id="phoneInput">
            <div>
                <div id="loginPhoneFlex" className="RFlex">
                    <img src="./images/otherIcons/corona-2.svg" className="corona" alt="corona" />
                    <br /> <br /> <br /><br /> <br />
                    {!isPinSent ?
                        <img src={`/images/otherIcons/phone.svg`} className="phoneIcon" alt="phone" title="phone" /> :
                        <img src={`/images/otherIcons/password.svg`} className="passIcon" alt="password" title="password" />

                    }</div>
                <br />
                {!isPinSent ?
                    <div className="question" id="phoneTitle">היי! נוכל לבקש את מספר הטלפון שלך?</div> :
                    <div className="question" id="phoneTitle">מה קוד האימות <br /> שנשלח אליך?</div>
                }
                {!isPinSent ?
                    (<div>
                        {fieldsToShow[0]}
                        <br />
                        <div id="infoDiv">נשתמש בו כדי לשלוח לך קוד אימות ולאחר מכן כדי לקשר אותך להתנדבות המתאימה לך</div>
                    </div>)
                    : fieldsToShow[1]
                }

                <div className="futter">
                    <p>1/8</p>
                    <button onClick={!isPinSent ? sendPin : login} /* disabled={!isPinSent ? !validateForm({ phone: fieldsState.phone }) : !validateForm({ pincode: fieldsState.pincode })} */>
                        המשך
                    </button>
                </div>
            </div>
            {isErrorPopup &&
                <FieldsErrorPopup
                    text="אנא וודא שהכנסת את מספר הטלפון שלך ואת הקוד שקיבלת"
                    closePopup={() => { setIsErrorPopup(false) }}
                />
            }
        </div>
    );
}

export default LoginWithPhone;
